export default __webpack_public_path__ + "static/media/food3_thumb.8e258269.jpg";